import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { intersection, keys, mapValues, union, values } from 'lodash';
import { map, Observable } from 'rxjs';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { AnnotationsService } from '../../services/annotations.service';
import { ItemService } from '../../services/item.service';

@Component({
  selector: 'h3-bulk-edit-view',
  templateUrl: './bulk-edit-view.component.html',
  styleUrl: './bulk-edit-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, MatIconModule],
})
export class BulkEditViewComponent implements OnInit {
  private readonly store = inject(TaskWorkspaceStore);
  private readonly itemService = inject(ItemService);
  private readonly annotationsService = inject(AnnotationsService);

  protected selectedItemsCount$ = this.store('objectSelection').$.pipe(
    map((objectSelection) => keys(objectSelection).length),
  );

  protected attributeIntersectionCount$!: Observable<number>;
  protected attributeUnionCount$!: Observable<number>;

  ngOnInit() {
    this.calculateAttributeCounts();
  }

  protected close() {
    this.store('categorizationAnnotationPanel')('isOpen').set(false);
  }

  private calculateAttributeCounts() {
    const annotationNamesPerItem$ = this.store('objectSelection').$.pipe(
      map((objectSelection) =>
        mapValues(objectSelection, (_, itemId) => {
          const annotationStores =
            this.itemService.getAnnotationStoresForItem$(+itemId);

          return annotationStores.map((annotationStore) =>
            this.annotationsService.getAnnotationName(annotationStore.state()),
          );
        }),
      ),
    );

    this.attributeIntersectionCount$ = annotationNamesPerItem$.pipe(
      map(
        (annotationsPerItem) =>
          intersection(...values(annotationsPerItem)).length,
      ),
    );

    this.attributeUnionCount$ = annotationNamesPerItem$.pipe(
      map((annotationsPerItem) => union(...values(annotationsPerItem)).length),
    );
  }
}
